import React, { useState, useEffect, useRef } from 'react';
import { FilledButton } from './Button';
import { FaChevronDown } from "react-icons/fa6";
import { BoldChip, Chip } from './Chip';
import TextInputField from './TextInputField';

type MultiTextSelectProps = {
    elements: string[];
    setElements: (elements: string[]) => void;
    maxNumSelections?: number,
    label?: string; // Optional label for the dropdown
    placeholder?: string;
    caption?: string;
    theme?: 'primary' | 'secondary';
};

const MultiTextSelect: React.FC<MultiTextSelectProps> = ({
    elements,
    setElements,
    maxNumSelections,
    label,
    placeholder,
    caption = "To add, press 'Enter' or ','",
    theme = 'primary'
}) => {
    const [currentValue, setCurrentValue] = useState('');

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' || event.key === ',') {
            event.preventDefault(); // Prevent the default action (like a form submission)
            if (currentValue.trim()) { // Ensure the input is not empty
                addElement(currentValue.trim()); // Call the addElement function
                setCurrentValue(''); // Clear the input field
            }
        }
    };

    const addElement = (elem: any) => {
        if (maxNumSelections && elements.length >= maxNumSelections || elements.includes(elem)) {
            return;
        }

        const newElements = [...elements, elem]
        setElements(newElements)
    }

    const removeElement = (elem: any) => {
        const newElements = elements.filter((element: any) => element !== elem);
        setElements([...newElements])
    }

    return (
        <div className="">

            <TextInputField
                value={currentValue}
                onChange={(e) => { setCurrentValue(e.target.value); }}
                placeholder={placeholder}
                caption={caption}
                label={label}
                onKeyDown={handleKeyDown}
            />

            {/* Show selections as chip with delete button */}
            {elements.length > 0 && <div className='flex flex-wrap gap-2 mt-1'>
                {elements.map((element: any) => (
                    <div key={element}>
                        <Chip
                            theme={theme}
                            onDelete={
                                () => removeElement(element)
                            }
                        >{element}</Chip>
                    </div>))}
            </div>}


        </div >
    );
};

export default MultiTextSelect;
